import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const ZellePayQRCode = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/ZelleQRCode.png" style={style} />
}
